import { IResultError } from "../../interfaces/results/IQuoteResult";
import QuoteErrorType from "../../enums/QuoteErrorType";

export const isBlockingError = (error: IResultError): boolean => {
    return error.type !== QuoteErrorType.MinimumPremium;
};
